import { useImpState } from '../../app/hooks';
import close from '../../assets/icons/close.svg';
import Button from '../button/Button';
import DynamicQRCode from '../dynamicQRCode/dynamicQRCode';
import styles from '../popup/Popup.module.css';

interface SelectionModalProps {
  header: string;
  body: string;
  buttonName1?: string;
  buttonName2?: string;
  button1Click?: any;
  button2Click?: any;
  handleCloseBtn: any;
  pillBtn1?: boolean;
  pillBtn2?: boolean;
  showQR?: boolean;
  qr?: string;
  qrMessage?: string;
  bodyButtonName?: string;
  bodyButtonClick?: any;
  pillBodyButton?: boolean;
  appDownload?: boolean;
}

export default function Modal({
  header,
  body,
  buttonName1,
  buttonName2,
  button1Click,
  button2Click,
  handleCloseBtn,
  pillBtn1,
  pillBtn2,
  showQR,
  qr,
  qrMessage,
  bodyButtonName,
  bodyButtonClick,
  pillBodyButton,
  appDownload,
}: SelectionModalProps) {
  const { language } = useImpState();

  if (language === null) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button onClick={() => handleCloseBtn()} className={styles.closeButton}>
          <img src={close} alt="close button" />
        </button>
        <p className={styles.header}>{header}</p>
        <p className={styles.body}>{body}</p>
        {showQR && (
          <div className={styles.qrCode}>
            <DynamicQRCode width="80" height="80" image={qr || ''} />
          </div>
        )}
        {qrMessage && <p className={styles.qrMessage}>{qrMessage}</p>}
        {bodyButtonName && (
          <div
            className={
              appDownload
                ? `${styles.bodyButton} ${styles.appDownload}`
                : styles.bodyButton
            }
          >
            <Button
              value={bodyButtonName}
              pill={pillBodyButton ? true : false}
              handleClick={() => bodyButtonClick()}
            />
          </div>
        )}
        {buttonName1 && (
          <div className={styles.button1}>
            <Button
              value={buttonName1}
              pill={pillBtn1 ? true : false}
              handleClick={() => button1Click()}
            />
          </div>
        )}
        {buttonName2 && (
          <div className={styles.button2}>
            <Button
              value={buttonName2}
              pill={pillBtn2 ? true : false}
              handleClick={() => button2Click()}
            />
          </div>
        )}
      </div>
    </div>
  );
}
